import { useEffect, useRef } from "react";
import { EventsForReview } from "src/store/api/generatedApi";

export const useSupersededReviewEventsResponse = ({
  windowKey,
  resolvedResponse,
}: {
  windowKey: string;
  resolvedResponse: EventsForReview | undefined;
}): EventsForReview | undefined => {
  const lastResolvedRef = useRef<{
    windowKey: string;
    response: EventsForReview;
  } | null>(null);

  useEffect(() => {
    if (resolvedResponse) {
      lastResolvedRef.current = { windowKey, response: resolvedResponse };
    }
  }, [resolvedResponse, windowKey]);

  return lastResolvedRef.current?.windowKey === windowKey
    ? lastResolvedRef.current.response
    : undefined;
};
